import {Component, OnDestroy, OnInit} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from '../../services/authentication.service';
import {TemplateService} from '../../services/template.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {Subscription} from "rxjs";
import * as moment from "moment";

@Component({
  selector: 'app-rd-send-report',
  templateUrl: './rd-send-report.component.html',
  styleUrls: ['./rd-send-report.component.scss'],
  providers: [TemplateService]
})

export class RDSendReportComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;
  selectedCompany: SelectItem[];
  company: any;
  selectedVerifiedAccount: SelectItem[];
  allBranch = true;
  allDocType = true;
  branch: any;
  documentType: any;
  selectedValues: boolean[] = [];
  allChecked: boolean = false;
  tableData: any;
  tableDataDisplay: any;
  statistic: any;
  modal: NgbModalRef;
  currentPage = 1;
  totalItems: number;
  loading = false;
  no_data = true;
  value = 0;
  sum_docs_count = 0;
  errorMsg = '';
  canManualResend: boolean;
  resendAllPendingMessage = '';
  monthListDropdown = [
    {label: 'มกราคม', value: 1},
    {label: 'กุมภาพันธ์', value: 2},
    {label: 'มีนาคม', value: 3},
    {label: 'เมษายน', value: 4},
    {label: 'พฤษภาคม', value: 5},
    {label: 'มิถุนายน', value: 6},
    {label: 'กรกฎาคม', value: 7},
    {label: 'สิงหาคม', value: 8},
    {label: 'กันยายน', value: 9},
    {label: 'ตุลาคม', value: 10},
    {label: 'พฤศจิกายน', value: 11},
    {label: 'ธันวาคม', value: 12}
  ];
  yearList: any[] = [];
  selectedMonth: any;
  selectedYear: any;
  index = 0;
  uploaded_row_count: 0;
  total_rows_count: 0;
  branchList: any = null;
  selectedBranch: SelectItem[];
  allBranchList: any = null;
  sortBy: string;
  sortMode: string;
  is_TH = false;

  rdDocumentType: any;
  selectedRdDocumentType: any;
  rdStatusDropdown = [];
  selectedStatus: string | null;

  tableCol = [];

  filterAcceptedSelected = false;
  filterRejectedSelected = false;
  filterPendingSelected = false;
  subs: Subscription;
  rdSummaryDetails = [];

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private authService: AuthenticationService,
              private template: TemplateService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.populateDropdown();
    });
    this.populateDropdown();
    this.searchData();
  }

  get currentLang(): string {
    return this.translate.currentLang;
  }

  populateDropdown() {
    this.loadCompanyAndBranch();
    this.loadDocumentType();
    this.loadRDStatus();
    this.loadTableHeader();
    this.loadMonthYear();
  }

  loadMonthYear() {
    this.monthListDropdown = [
      {label: this.translate.instant('MONTH.JANUARY'), value: 1},
      {label: this.translate.instant('MONTH.FEBRUARY'), value: 2},
      {label: this.translate.instant('MONTH.MARCH'), value: 3},
      {label: this.translate.instant('MONTH.APRIL'), value: 4},
      {label: this.translate.instant('MONTH.MAY'), value: 5},
      {label: this.translate.instant('MONTH.JUNE'), value: 6},
      {label: this.translate.instant('MONTH.JULY'), value: 7},
      {label: this.translate.instant('MONTH.AUGUST'), value: 8},
      {label: this.translate.instant('MONTH.SEPTEMBER'), value: 9},
      {label: this.translate.instant('MONTH.OCTOBER'), value: 10},
      {label: this.translate.instant('MONTH.NOVEMBER'), value: 11},
      {label: this.translate.instant('MONTH.DECEMBER'), value: 12}
    ];
    const currentDate = new Date();
    // populate year list back within 10 years
    const thisYear = currentDate.getFullYear();
    for (let i = 0; i <= 10; i++) {
      this.yearList.push({label: (thisYear - i).toString(), value: thisYear - i});
    }

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = thisYear;
  }

  loadDocumentType() {
    const documentData = this.template.getDropdown();
    documentData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
    this.rdDocumentType = documentData;
    this.selectedRdDocumentType = null;
  }

  loadTableHeader() {
    this.tableCol = [
      {field: 'branch', header: this.translate.instant('TABLE.BRANCH-NAME')},
      {field: 'rd_document_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE')},
      {field: 'identifier', header: this.translate.instant('TABLE.DOCUMENT-NUMBER')},
      {field: 'header_issue_dt', header: this.translate.instant('RD-SEND-REPORT.ISSUE-DATE')},
      {field: 'created_at', header: this.translate.instant('RD-SEND-REPORT.SEND-DATE')},
      {field: 'conversation_id', header: this.translate.instant('RD-SEND-REPORT.CONVERSATION-ID')},
      {field: 'sent_to_rd', header: this.translate.instant('RD-SEND-REPORT.SENT-TO-SP')},
      {field: 'rd_acknowledged', header: this.translate.instant('RD-SEND-REPORT.RD-ACKNOWLEDGED')},
      {field: 'rd_status', header: this.translate.instant('RD-SEND-REPORT.RESULT.STATUS')},
    ];
  }

  loadCompanyAndBranch() {
    this.company = [];
    this.apiService.getCompany().subscribe(
      (result) => {
        this.company = [{
          label: this.translate.instant('COMMON.ALL'),
          value: null
        }]
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
        this.selectedCompany = null;
      }
    );
    this.apiService.getBranch().subscribe(
      (result) => {
        this.allBranchList = result;
        this.filterBranchList();
      }
    );
  }

  filterBranchList() {
    this.selectedBranch = null;

    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allBranchList, (obj) => {
      if (this.selectedCompany == null || obj.corporate === this.selectedCompany) {
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        });
      }
    });
  }

  loadRDStatus() {
    this.rdStatusDropdown = [
      {
        label: this.translate.instant('COMMON.ALL'),
        value: null,
      },
      {
        label: this.translate.instant('RD-SEND-REPORT.RESULT.PENDING'),
        value: 'pending',
      },
      {
        label: this.translate.instant('RD-SEND-REPORT.RESULT.REJECTED'),
        value: 'rd_rejected',
      },
      {
        label: this.translate.instant('RD-SEND-REPORT.RESULT.ACCEPTED'),
        value: 'rd_accepted',
      },
    ];
    this.selectedStatus = null;
  }

  pageChanged() {
    this.searchData();
    this.allChecked = false;
  }

  searchData() {
    this.loading = true;
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }

    const params = {
      month: this.selectedMonth || '',
      year: this.selectedYear || '',
      company_id: this.selectedCompany || '',
      branch_id: this.selectedBranch ? this.selectedBranch : '',
      items_per_page: this.itemsPerPage,
      rd_doc_type: this.selectedRdDocumentType || '',
      status: this.selectedStatus || '',
    };

    if (this.currentPage > 1) {
      params['page'] = this.currentPage;
    }

    if (this.sortBy) {
      params['ordering'] = this.sortMode + this.sortBy;
    }

    this.apiService.getRDSendReport(params).subscribe(
      (result) => {

        // Check if result object is empty
        if (Object.keys(result).length != 0 || result.constructor != Object) {
          this.loading = false;
          this.tableData = result.results;
          this.tableDataDisplay = this.tableData;
          this.no_data = _.isEmpty(this.tableData);
          this.totalItems = result.count;
          this.statistic = result.statistic;
          this.rdSummaryDetails = result.results
          this.selectedValues = Array(this.tableData.length).fill(false);
        }
      },
      error => {
        this.loading = false;
        this.no_data = true;
        this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
      }
    );
    this.getLatestManualResendTime();
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.searchData();
  }

  getLatestManualResendTime() {
    const data = {
      month: this.selectedMonth,
      year: this.selectedYear,
    };
    this.apiService.getLatestManualResendTime(data).subscribe(
      (result) => {
        this.canManualResend = result.can_manual_resend;
      },
      error => {
        console.log('error', error);
      }
    );
  }

  closeResendAllPending() {
    this.modal.close();
    this.searchButtonClicked();
  }

  resendAllPending(content) {
    const data = {
      month: this.selectedMonth,
      year: this.selectedYear,
    };
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});
    this.apiService.resendAllPendingEbxml(data).subscribe(
      (res: any) => {
        this.resendAllPendingMessage = res.msg;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  clearData() {
    const currentDate = new Date();
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = currentDate.getFullYear();
    this.selectedCompany = null;
    this.selectedVerifiedAccount = null;
    this.branch = null;
    this.documentType = null;
    this.allDocType = true;
    this.allBranch = true;
    this.selectedBranch = null;
    this.selectedRdDocumentType = null;
    this.selectedStatus = null;

    this.searchButtonClicked();
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.branch) && this.allBranch === false) {
      errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' +
        this.translate.instant('COMMON.CORRECT');
    }
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = '';
    } else {
      this.sortMode = '-';
    }
  }

  // resend function is not used now
  resend(taxDataId: number) {
    this.apiService.resendToRD(taxDataId).subscribe(
      (res: any) => {
        this.searchData();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  EnabledDownloadSelected() {
    return this.selectedValues.filter(select => select === true).length > 0;
  }

  selectDeselectAll(checked: boolean): void {
    this.selectedValues = Array(this.tableData.length).fill(checked);
    this.allChecked = checked;
  }

  isAllSelect(): void {
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        this.allChecked = false;
        return;
      }
    }
    this.allChecked = true;
  }

  getSelectId(): string {
    const selectedId = [];
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (this.selectedValues[i]) {
        selectedId.push(this.tableData[i].id);
      }
    }
    return selectedId.join(',');
  }

  getExportExcel() {
    const params = {
      search_box: this.getSelectId(),
    };

    this.apiService.getRDSummaryExcel(params).subscribe(
      (obj) => {
        const currentDate = moment().format('DD-MM-YYYY');
        const filename = `${currentDate}_department_export.xlsx`;
        this.apiService.createDownloadFile(obj, filename);
      },
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/rd-send-report/rd-send-report.component.ts